import ApiService from '../index'

export const email = async (params) => {
  const URI = '/api/user/clients'

  const response = await ApiService.post(URI, params)

  return response.data
}

export const login = async (params) => {
  const URI = '/api/login'

  const response = await ApiService.post(URI, params)

  return response.data
}

export const token = async (params) => {
  const URI = '/api/oauth/token'

  const response = await ApiService.post(URI, params)

  return response.data
}
